import { useEffect } from "react";

import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { ConnectedRouter } from "connected-react-router";

import { IRoute } from "@/common/interfaces";

import history from "./history";
import routes from "./routes";
import NavbarContainer from "../common/containers/NavbarContainer";

const mapStateToProps = (state: any) => {
  return {
    isLogged: state.authReducer.isLogged,
    user: state.authReducer.user,
  };
};

const connector = connect(mapStateToProps);

type TRoutes = {
  isLogged: boolean;
  user: any;
};

const Routes = ({ isLogged, user }: TRoutes) => {
  // TODO REDIRECT
  useEffect(() => {
    if (isLogged === true) {
      if (history.location.pathname.includes("login")) {
        history.push("/");
      }
    } else {
      if (
        !history.location.pathname.includes("/confirmation") &&
        !history.location.pathname.includes("/reset-password")
      ) {
        history.push("/login");
      }
    }
  }, [isLogged, user]);

  const renderRoutes = () => {
    return routes.map((route: IRoute) => {
      const { key, ...routeWithoutKey } = route;

      return <Route key={key} {...routeWithoutKey} />;
    });
  };

  return (
    <ConnectedRouter history={history}>
      <NavbarContainer>
        <Switch>{renderRoutes()}</Switch>
      </NavbarContainer>
      <ToastContainer theme="colored" />
    </ConnectedRouter>
  );
};

export default connector(Routes);
